<template>
  <form @submit.prevent="requestSubmit">

    <div class="form-control" :class="{invalid: nError}">
      <label for="name">ФИО</label>
      <input type="text" id="name" v-model="name" @blur="nBlur" disabled>
      <small v-if="nError">{{nError}}</small>
    </div>

    <div class="form-control" :class="{invalid: pError}">
      <label for="phone">Телефон</label>
      <input type="text" id="phone" v-model="phone" @blur="pBlur" disabled>
      <small v-if="pError">{{pError}}</small>
    </div>

    <div class="form-control" :class="{invalid: cError}">
      <label for="contract">Номер договора</label>
      <input type="text" id="contract" v-model="contract" @blur="cBlur" disabled>
      <small v-if="cError">{{cError}}</small>
    </div>

    <div class="form-control" :class="{invalid: mError}">
      <label for="message">Комментарий</label>
      <input type="text" id="message" v-model="message" @blur="mBlur">
      <small v-if="mError">{{mError}}</small>
    </div>

    <button class="btn primary" :disabled="isSubmitting">Отправить</button>
  </form>
</template>

<script>  // Тут находится наша форма, которая выскакивает в модальном окне

import {useRequestForm} from "../use/request-form";
import {useStore} from "vuex";

export default {
  emits: ['created'],
  setup(_, {emit}) {
    const store = useStore()

    const fio = store._state.data.auth.loginData.name
    const document = store._state.data.auth.loginData.contract
    const mobile = store._state.data.auth.loginData.phone



    const submit = async values => {
      await store.dispatch('request/saveRequest', values)
      emit('created')
    }


    return {
      ...useRequestForm(submit, fio, document, mobile)  // чтобы эти данные были доступны в нашем шаблоне, через v-model связываем данные в шаблоне
    }
  }

}
</script>

<style scoped>

</style>